import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";

export const Card = styled(FlexColumn)`
    gap: 4px;
    border-left: 1px solid ${colorsPalettes.sky[100]};
    padding: 4px 8px;
`;

export const CardTitle = styled.div`
    ${setFontVariant("listItem1", colorsPalettes.midnight[400])};
`;

export const CardText = styled.div`
    ${setFontVariant("body2", colorsPalettes.midnight[400])};
`;
